import PropTypes from 'prop-types';
import React from 'react';

import SortableHeaderComponent from './../Components/SortableHeaderComponent.jsx';
import { metrics as constants, unicode } from './../helpers';

const durationHeaders = [
  {
    sorterId: constants.metricsSorterTypes.SORT_DURATION_CURRENT,
    text: 'Current',
    style: {
      whiteSpace: 'nowrap',
      minWidth: '60px'
    }
  },
  {
    sorterId: constants.metricsSorterTypes.SORT_DURATION_BASELINE,
    text: 'Baseline',
    style: {
      whiteSpace: 'nowrap',
      minWidth: '70px'
    }
  },
  {
    sorterId: constants.metricsSorterTypes.SORT_DURATION_PERCENT,
    text: `${unicode.DELTA}%`,
    style: {
      whiteSpace: 'nowrap',
      minWidth: '25px'
    }
  },
  {
    extraClassNames: 'divider-right',
    sorterId: constants.metricsSorterTypes.SORT_DURATION_DIFF,
    text: unicode.DELTA,
    style: {
      whiteSpace: 'nowrap',
      minWidth: '15px'
    }
  }
];

const hitHeaders = [
  {
    sorterId: constants.metricsSorterTypes.SORT_HITCOUNT_CURRENT,
    text: 'Current',
    style: {
      whiteSpace: 'nowrap',
      minWidth: '60px'
    }
  },
  {
    sorterId: constants.metricsSorterTypes.SORT_HITCOUNT_BASELINE,
    text: 'Baseline',
    style: {
      whiteSpace: 'nowrap',
      minWidth: '70px'
    }
  },
  {
    sorterId: constants.metricsSorterTypes.SORT_HITCOUNT_DIFF,
    text: unicode.DELTA,
    style: {
      whiteSpace: 'nowrap',
      minWidth: '15px'
    }
  },
  {
    sorterId: constants.metricsSorterTypes.SORT_HITCOUNT_DIFFRESULT,
    text: 'Result',
    style: {
      whiteSpace: 'nowrap',
      minWidth: '40px'
    }
  },
  {
    extraClassNames: 'divider-right',
    sorterId: constants.metricsSorterTypes.SORT_HITCOUNT_MCAT,
    text: 'MCAT',
    style: {
      whiteSpace: 'nowrap',
      minWidth: '20px'
    }
  }
];

const sourceCountHeaders = [
  {
    sorterId: constants.metricsSorterTypes.SORT_SOURCECOUNT_CURRENT,
    text: 'Current',
    style: {
      whiteSpace: 'nowrap',
      minWidth : '60px'
    }
  },
  {
    sorterId: constants.metricsSorterTypes.SORT_SOURCECOUNT_BASELINE,
    text: 'Baseline',
    style: {
      whiteSpace: 'nowrap',
      minWidth : '70px'
    }
  },
  {
    sorterId: constants.metricsSorterTypes.SORT_SOURCECOUNT_DIFF,
    text: unicode.DELTA,
    style: {
      whiteSpace: 'nowrap',
      minWidth : '15px'
    }
  },
  {
    extraClassNames: 'divider-right',
    sorterId: constants.metricsSorterTypes.SORT_SOURCECOUNT_DIFFRESULT,
    text: 'Result',
    style: {
      whiteSpace: 'nowrap',
      minWidth: '40px'
    }
  }
];

const sourceAttributeCountHeaders = [
  {
    sorterId: constants.metricsSorterTypes.SORT_SOURCEATTRIBUTECOUNT_CURRENT,
    text: 'Current',
    style: {
      whiteSpace: 'nowrap',
      minWidth : '60px'
    }
  },
  {
    sorterId: constants.metricsSorterTypes.SORT_SOURCEATTRIBUTECOUNT_BASELINE,
    text: 'Baseline',
    style: {
      whiteSpace: 'nowrap',
      minWidth : '70px'
    }
  },
  {
    extraClassNames: 'divider-right',
    sorterId: constants.metricsSorterTypes.SORT_SOURCEATTRIBUTECOUNT_DIFF,
    text: unicode.DELTA,
    style: {
      whiteSpace: 'nowrap',
      minWidth : '15px'
    }
  }
];

const getHeaders = (hideDuration, showSources) => [
  ...(!hideDuration ? durationHeaders : []),
  ...hitHeaders,
  ...(showSources ? sourceCountHeaders : []),
  ...(showSources ? sourceAttributeCountHeaders : [])
];

const MetricsTableHeadersComponent = ({
  sorter,
  onSorterChange,
  isExpected,
  hideDuration,
  hideBuildNumbers,
  showSources
}) => {
  return (
    <thead>
      <tr>
        <SortableHeaderComponent
          id="image-sorter"
          currentSorter={sorter}
          onSorterChange={onSorterChange}
          mySorterId={constants.metricsSorterTypes.SORT_IMAGE}
          rowSpan="3"
          colSpan="2"
          text="Image Name"
          style={{ minWidth : '85px' }}
        />
        {
          !hideDuration &&
            <th
              className={'divider-right'}
              colSpan={4}
              scope="colgroup"
            >
              Duration (seconds)
            </th>
        }
        <th className={'divider-right'} colSpan={5} scope="colgroup">Hit Count</th>
        {
          showSources &&
            <th
              className={'divider-right'}
              colSpan={4}
              scope="colgroup"
            >
              Source Count
            </th>
        }
        {
          showSources &&
          <th
            className={'divider-right'}
            colSpan={3}
            scope="colgroup"
          >
            Source Attribute Count
          </th>
        }
        {
          !hideBuildNumbers &&
          <th
            className={'divider-right'}
            rowSpan="2"
            colSpan={1}
            style={{ minWidth : '55px' }}
          >
            Build
          </th>
        }
        {
          !hideDuration && isExpected && <th rowSpan="2" />
        }
      </tr>
      <tr>
        {
          getHeaders(hideDuration, showSources).map((h, i) =>
            <SortableHeaderComponent
              id={`metrics-table-sorter-${h.sorterId}`}
              key={i}
              currentSorter={sorter}
              onSorterChange={onSorterChange}
              mySorterId={h.sorterId}
              text={h.text}
              style={h.style}
              extraClassNames={h.extraClassNames}
            />
          )
        }
      </tr>
    </thead>
  );
};

MetricsTableHeadersComponent.propTypes = {
  sorter: PropTypes.shape({
    id: PropTypes.number.isRequired,
    ascending: PropTypes.bool.isRequired
  }).isRequired,
  onSorterChange: PropTypes.func.isRequired,
  isExpected: PropTypes.bool,
  hideDuration: PropTypes.bool,
  hideBuildNumbers: PropTypes.bool,
  showSources: PropTypes.bool
};

export default MetricsTableHeadersComponent;


// WEBPACK FOOTER //
// src/Components/MetricsTableHeadersComponent.jsx